import React from "react";
import "./Terms.css";
import { Link } from "react-router-dom";
import { useLocalContext } from "../../context/LocalContext";

const Terms = () => {
  const { webinfo = {} } = useLocalContext();
  const name = webinfo?.name || "smartprintersolutions.com";
  const email = webinfo?.email || "contact@smartprintersolutions.com";

  return (
    <div className="terms-wrapper">
      <div className="terms-header">
        <h1>Terms of use</h1>
        <p>
          These Terms of Use govern your access to the website operated by <strong>{name}</strong> and describe how we
          provide digital marketing services. By using the site or engaging us, you agree to these terms, our{" "}
          <Link to="/privacy-policy">Privacy Policy</Link>, and <Link to="/disclaimer">Disclaimer</Link>.
        </p>
      </div>

      <div className="terms-content">
        <div className="terms-section">
          <h2>1. Services</h2>
          <p>
            We offer digital marketing strategy and execution (for example SEO, paid media, social, email, analytics).
            Specific deliverables, fees, timelines, and responsibilities are defined in a separate proposal, statement of
            work, or master services agreement. If there is a conflict, the signed engagement document controls.
          </p>
        </div>

        <div className="terms-section">
          <h2>2. No performance guarantees</h2>
          <p>
            We do not guarantee rankings, traffic, leads, sales, return on ad spend, or other marketing outcomes.
            Platforms, algorithms, and competitors change. Any projections are illustrative unless expressly written as
            a binding commitment in a signed contract (which is rare).
          </p>
        </div>

        <div className="terms-section">
          <h2>3. Client responsibilities</h2>
          <p>
            You agree to provide accurate information, timely approvals, lawful creative assets, and access to
            accounts we reasonably need. Delays or restrictions may affect timelines and results. You remain responsible
            for your product claims, pricing, and legal compliance.
          </p>
        </div>

        <div className="terms-section">
          <h2>4. Payment</h2>
          <p>
            Fees, deposits, and invoicing schedules are set in your agreement. Late payment may pause work or incur fees
            as described there. Unless stated otherwise, amounts are quoted in USD and exclude taxes you owe.
          </p>
        </div>

        <div className="terms-section">
          <h2>5. Intellectual property</h2>
          <p>
            You retain rights to your pre-existing materials. Deliverables we create for you are licensed or assigned as
            stated in your agreement. Until payment in full, we may retain usage rights as described in that agreement.{" "}
            {name} may show anonymized or approved portfolio examples unless an NDA says otherwise.
          </p>
        </div>

        <div className="terms-section">
          <h2>6. Confidentiality &amp; data</h2>
          <p>
            Each party will protect the other&apos;s confidential information. Handling of personal data is described in
            our Privacy Policy and any data processing terms in your contract. You warrant you have authority to share
            data you provide for campaigns.
          </p>
        </div>

        <div className="terms-section">
          <h2>7. Third-party platforms</h2>
          <p>
            Ad platforms, analytics vendors, and social networks have their own terms. You are responsible for complying
            with them. We may suspend work if your assets or instructions violate platform policies or law.
          </p>
        </div>

        <div className="terms-section">
          <h2>8. Termination</h2>
          <p>
            Either party may end an engagement as set forth in the governing agreement. You pay for work completed and
            non-cancellable media spend incurred through the termination date unless otherwise agreed in writing.
          </p>
        </div>

        <div className="terms-section">
          <h2>9. Limitation of liability</h2>
          <p>
            To the fullest extent permitted by law, {name} is not liable for indirect, incidental, special,
            consequential, or punitive damages, or lost profits, arising from our services or this website. Our total
            liability for any claim is limited to the fees you paid {name} for the specific services giving rise to the
            claim during the three months before the event (or $100 if no fees were paid), except where limited by law.
          </p>
        </div>

        <div className="terms-section">
          <h2>10. Indemnity</h2>
          <p>
            You will indemnify {name} against third-party claims arising from your products, your landing pages, your
            instructions, or your misuse of deliverables, except to the extent caused by our willful misconduct.
          </p>
        </div>

        <div className="terms-section">
          <h2>11. Governing law</h2>
          <p>
            These Terms are governed by the laws of the state or jurisdiction in which {name} primarily operates,
            without regard to conflict-of-law rules, except where applicable federal law controls. Courts in that
            jurisdiction (where competent) have venue unless a statute requires otherwise.
          </p>
        </div>

        <div className="terms-section">
          <h2>12. Website use</h2>
          <p>
            You may not scrape the site in violation of our policies, introduce malware, or attempt unauthorized access.
            Content on the site is for information; it does not amend a signed contract unless explicitly stated.
          </p>
        </div>

        <div className="terms-section">
          <h2>13. Changes</h2>
          <p>
            We may update these Terms by posting a new version. Continued use of the website after changes means you
            accept the update. Active client agreements may have their own change rules.
          </p>
        </div>

        <div className="terms-section">
          <h2>14. Contact</h2>
          <p>
            Questions: <a href={`mailto:${email}`}>{email}</a> or our <Link to="/contact">contact page</Link>.
          </p>
        </div>

        <div className="contact-info">
          <Link to="/contact">Contact us</Link>
        </div>
      </div>
    </div>
  );
};

export default Terms;
